var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoJackson = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jackon-nursing-professionals-logo 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7136 4.81902C23.2164 -1.61652 12.7353 -1.61652 6.29943 4.88032C0.415254 10.7642 -0.197681 20.1418 4.88968 26.7612C5.13486 27.0676 5.44132 27.4354 5.6865 27.7418L18.0065 40L30.2652 27.7418C30.5717 27.4354 30.8168 27.1289 31.062 26.7612C33.3299 23.8805 34.5558 20.2643 34.5558 16.6482C34.617 12.1739 32.8395 7.94486 29.7136 4.81902Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.87069 16.7094C5.87069 9.96738 11.3258 4.51249 18.0681 4.51249C24.8104 4.51249 30.2655 9.96738 30.2655 16.7094C30.2655 16.832 30.2655 17.0158 30.2655 17.1384H31.7978C31.7978 17.0158 31.7978 16.832 31.7978 16.7094C31.7978 9.1706 25.6685 3.0415 18.1294 3.0415C10.5903 3.0415 4.46094 9.1706 4.46094 16.7094C4.46094 16.832 4.46094 17.0158 4.46094 17.1384H5.99328C5.87069 17.0158 5.87069 16.832 5.87069 16.7094Z",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.01637 16.7096C8.01637 11.1934 12.4908 6.71916 18.0072 6.71916C23.5236 6.71916 27.9981 11.1934 27.9981 16.7096C27.9981 16.8322 27.9981 17.016 27.9981 17.1386H30.1433C30.1433 17.016 30.1433 16.8322 30.1433 16.7096C30.1433 10.0289 24.7495 4.57397 18.0072 4.57397C11.3262 4.57397 5.87109 10.0289 5.87109 16.7096C5.87109 16.8322 5.87109 17.016 5.87109 17.1386H8.01637C8.07766 17.016 8.01637 16.8322 8.01637 16.7096Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.9372 16.7094C27.9372 11.2545 23.5241 6.78027 18.0077 6.78027C12.5526 6.78027 8.07812 11.1932 8.07812 16.7094C8.07812 16.832 8.07812 17.0159 8.07812 17.1384H27.8759C27.9372 17.0159 27.9372 16.832 27.9372 16.7094Z",
    fill: "#FFCC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.3533 13.8288L18.25 12.9707L19.721 14.1352L22.2341 16.1578L23.7051 17.3224H23.7664C22.2341 16.2191 20.763 14.9933 19.3533 13.8288Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.3546 13.8288C20.8256 14.9933 22.2354 16.2191 23.7064 17.3836H28.9164L23.829 13.2158L22.7257 14.1352L18.3126 10.519L15.7383 12.6642L17.2093 13.89L18.3126 13.032L19.3546 13.8288Z",
    fill: "#487738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.2517 15.9126L17.1484 16.7707L18.2517 15.9126Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.2283 17.1998L23.7698 10.2739L22.6665 11.1933L18.2534 7.57715L16.7823 8.74168L14.6983 10.4578L13.8402 11.1933L12.7369 10.2739L5.44301 16.1579L2.74609 18.4256C2.80739 19.0385 2.92997 19.6515 3.05256 20.2644H4.64619C4.64619 20.1418 4.5849 20.0805 4.5849 19.9579C4.40102 19.1611 4.33973 18.3031 4.27843 17.445H7.64958L12.7369 13.2772L17.0888 16.8321L18.1308 15.974H18.1921L19.9696 17.445H23.5246L22.0536 16.2805L19.6631 14.1353L18.1921 12.9707L17.0888 13.8288L15.6177 12.603L18.1921 10.4578L22.6052 14.074L23.7085 13.1546L28.7958 17.3224H31.6766C31.6766 17.7514 31.6153 18.1805 31.5541 18.6095L32.2283 17.1998Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.1484 13.8288L18.2517 12.9707H18.1904L17.1484 13.8288Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.2534 15.9126L17.2114 16.7707H17.1501L15.4952 15.4223L14.2693 14.3803L12.7983 13.2158L7.71094 17.3836H20.0309C19.418 16.8933 18.8051 16.4029 18.2534 15.9126Z",
    fill: "#487738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.0888 17.3836L18.3113 15.9126H18.25C18.8016 16.4029 19.4146 16.8933 20.0888 17.3836Z",
    fill: "#487738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.4325 15.4223L17.0874 16.7707H17.1487L12.7969 13.2158L14.2066 14.3803L15.4325 15.4223Z",
    fill: "#487738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31.6126 18.7935L31.1836 19.8967H31.4288C31.4901 19.4677 31.6126 19.0999 31.6126 18.6709V18.7322V18.7935Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.3143 30.8063C21.0112 30.745 23.463 29.887 25.6083 28.5386H10.4688C12.7366 30.0096 15.4335 30.8676 18.3143 30.8063Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M20.7016 17.9352L20.0886 17.3835H20.0273C20.2112 17.5674 20.4564 17.7513 20.7016 17.9352Z",
    fill: "#0F344C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M31.0633 20.2642H24.6274C24.4436 20.2642 24.2597 20.2642 24.0758 20.2029H4.70703C4.76832 20.5707 4.89091 20.9384 5.0135 21.3062H31.1245C31.2471 20.8771 31.3697 20.3868 31.4923 19.8965H31.2471L31.0633 20.2642Z",
    fill: "#1BBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M24.0742 20.2029C24.2581 20.2642 24.442 20.2642 24.6259 20.2642H31.0617L31.1843 19.8965H26.7098L27.0776 20.2029H24.0742Z",
    fill: "#1BBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M23.2153 19.8965H4.58203C4.58203 20.0191 4.64332 20.0804 4.64332 20.2029H24.0121C23.7669 20.1416 23.4604 20.0804 23.2153 19.8965Z",
    fill: "#1BBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M24.073 20.2029H27.1376L26.7699 19.8965H23.2148C23.46 20.0804 23.7665 20.1416 24.073 20.2029Z",
    fill: "#1BBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.7878 24.9224H29.2825C29.589 24.4933 29.8955 24.003 30.1406 23.5127H5.92969C6.17486 24.003 6.48133 24.4933 6.7878 24.9224Z",
    fill: "#1BBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M10.4689 28.5386H25.6084C26.2214 28.1096 26.8343 27.6805 27.3859 27.1289H8.69141C9.24305 27.6192 9.85598 28.1096 10.4689 28.5386Z",
    fill: "#1BBFD7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoJackson, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-jackson.00ee628e.svg";
export { ForwardRef as ReactComponent };